module.exports = __webpack_public_path__ + "static/media/bv.39bc7c97.svg";